import React from "react";
import R14, { StyleSheet, View, Text, Image} from "../core";
import Touchable from "./TouchableComponent";
import { commonStyles } from "../assets/css/commonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { STATUS_CLR } from "../constant/app.data.constant";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import imgpath from "../assets/images/bookmared_active.png";

export default R14.connect(
  class StatusComponent extends React.Component {
    render() {
      let currentRoute = this.props.r14.navigation.activeRouteName;
      const {
        label,
        toggleStatus,
        isSelected,
        hasClose,
        onCrossClick,
        marginRight,
        marginBottom,
        paymentStatusLabel,
        circleNotAllowed,
        isBackground,
        fontWeight,
        statusTextAlignment,
        isStatusColor,
        statusWrapStyle,
        wrapperStyle,
      } = this.props;
      let statusLabel = !!paymentStatusLabel ? paymentStatusLabel : label;
      return (
        <View style={[
          isBackground, isSelected ? styles[STATUS_CLR[statusLabel]] : null, styles.margingBtm,
          commonStyles.marginRight5,
          currentRoute === "bulkPaymentRoutes" || currentRoute === "makePaymentRoutes" || currentRoute === "dashboardNavigator" ? styles.customPadding : commonStyles.filterChips,
          !!circleNotAllowed ? [styles.paddwithoutcircle, commonStyles.alignItemsCenter] : null,
          marginRight,
          marginBottom,
          hasClose ? [
            commonStyles.flex1,
            commonStyles.flexDirectionRow, commonStyles.flexGrow0, styles.borderRadius15] : null,
          isStatusColor ? styles.roundedBorder : null,
          isBackground && isSelected && isStatusColor ? styles.borderRadius15 : null,
          wrapperStyle
        ]}>
          <Touchable onPress={toggleStatus}>
            <View style={[
              commonStyles.flex1,
              commonStyles.alignItemsCenter,
              !!isStatusColor || !!circleNotAllowed || label === "Priority" ? null : customCommonStyles.withoutCircle,
              commonStyles.flexDirectionRow,
              statusWrapStyle
            ]}>
              {!!circleNotAllowed ? null : label === "Priority" ? (
                <Image source={imgpath} resizeMode="contain" style={[styles.bookedMark]} />
              ) : (
                !!isStatusColor ? (<Text
                  style={[commonStyles.statusColor, styles[STATUS_CLR[statusLabel]], isSelected ? styles.bgCls : null, styles.customMarginLeft5, commonStyles.marginRight5]}></Text>)
                  : null)}
              <Text
                style={[
                  commonStyles.smallHeading,
                  commonFontStyles.workSans,
                  commonStyles.fontWeight400,
                  commonStyles.exSmallHeading,
                  isSelected ? commonStyles.whiteColor : commonStyles.contentColor,
                  commonStyles.transformUpperCase,
                  styles.padding3,
                  fontWeight,
                  statusTextAlignment
                ]}>
                {statusLabel}
              </Text>
            </View>
          </Touchable>
          {hasClose ? (
            <Touchable tooltip={'Remove Filter'} onPress={onCrossClick} style={styles.closeIcon}>
              <View>
                <Text style={[commonStyles.heading6, styles.activeCls]}>&#10006;</Text>
              </View>
            </Touchable>
          ) : null}
        </View>
      );
    }
  })

const styles = StyleSheet.create({
  NW: {
    backgroundColor: "#1277d9",
  },
  PD: {
    backgroundColor: "#218666",
  },
  DL: {
    backgroundColor: "#B40220",
  },
  OD: {
    backgroundColor: "#FFA500",
  },
  OS: {
    backgroundColor: "#6500A7",
  },
  PB: {
    backgroundColor: "#d71996",
  },
  IP: {
    backgroundColor: "#B43FEE",
  },
  FD: {
    backgroundColor: "#B40220",
  },
  AD: {
    backgroundColor: "#218666",
  },
  RD: {
    backgroundColor: "#B40220",
  },
  DR: {
    backgroundColor: "#7accf6",
  },
  BU: {
    backgroundColor: "#218666",
  },
  RQD: {
    backgroundColor: "#16A0CA",
  },
  NP: {
    backgroundColor: "#1277d9",
  },
  DP: {
    backgroundColor: "#B40220",
  },
  AP: {
    backgroundColor: "#218666",
  },
  activeCls: {
    color: "#FFFFFF",
  },
  bgCls: {
    backgroundColor: "#FFFFFF",
  },
  margingBtm: {
    ...StyleSheet.margin(0, 0, 0, 0),
  },
  closeIcon: {
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 10,
    backgroundColor: "#00000000",
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    borderWidth: 0,
    height: "auto"
  },
  paddwithoutcircle: {
    paddingTop: 2,
    paddingRight: 10,
    paddingBottom: 2,
    paddingLeft: 10,
  },
  bookedMark: {
    height: 15,
    width: 15,
    backgroundSize: "contain",
    display: "block",
    screen: ({ width }) => {
      if (width <= 991)
        return {
          marginLeft: 5,
        };
    },
  },
  roundedBorder: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#e2e2e2",
    borderRadius: 15,
    maxHeight: 26,
  },
  borderRadius15: {
    borderRadius: 15,
    maxHeight: 26,
  },
  paddingRight0: {
    paddingRight: 0,
  },
  customPadding: {
    screen: ({ width }) => {
      if (width >= 991)
        return {
          paddingRight: 5,
          paddingLeft: 5,
        };
    },
  },
  customMarginLeft5: {
    screen: ({ width }) => {
      if (width <= 991)
        return {
          marginLeft: 5,
        };
    },
  },
  padding3: {
    paddingTop: 3,
    paddingRight: 3,
    paddingBottom: 3,
    paddingLeft: 3,
  }
});
